'use es6';

import { getFormsBatch, getForm, getAllFormsForComparison } from 'FormsUI/api/Forms';
import { getComparisonToolFormDefinition } from 'FormsUI/selectors/ComparisonTool';
import { getFormsDetailsForComparison } from 'FormsUI/api/Dashboard';
import { timestampToStartDate, timestampToEndDate } from 'FormsUI/utils/ComparisonTool';
import Log from 'forms-utils-lib/logger/Logger';
const createAction = name => `@@comparisonForms/${name}`;
export const REQUEST_COMPARISON_FORMS = createAction('REQUEST_COMPARISON_FORMS');
export const RECEIVE_COMPARISON_FORMS = createAction('RECEIVE_COMPARISON_FORMS');
export const FAIL_GETTING_COMPARISON_FORMS = createAction('FAIL_GETTING_COMPARISON_FORMS');
export const STORE_DASHBOARD_QUERY = createAction('STORE_DASHBOARD_QUERY');
const requestComparisonForms = (contentObject, startTimestamp, endTimestamp) => ({
  type: REQUEST_COMPARISON_FORMS,
  contentObject,
  startTimestamp,
  endTimestamp
});
const receiveComparisonForms = (contentObject, comparisonForms, startTimestamp, endTimestamp) => ({
  type: RECEIVE_COMPARISON_FORMS,
  contentObject,
  comparisonForms,
  startTimestamp,
  endTimestamp
});
const failGettingComparisonForms = (contentObject, fails, startTimestamp, endTimestamp) => ({
  type: FAIL_GETTING_COMPARISON_FORMS,
  contentObject,
  fails,
  startTimestamp,
  endTimestamp
});
export const storeDashboardQuery = storedDashboardQuery => ({
  type: STORE_DASHBOARD_QUERY,
  storedDashboardQuery
});
export const fetchForms = ({
  searchTerm = null,
  idsToSearch = []
}) => {
  const searchOptions = {};
  if (idsToSearch.length > 0) {
    searchOptions.id__in = idsToSearch;
  }
  if (searchTerm) {
    searchOptions.nameQuery = searchTerm;
  }
  return Promise.all([getAllFormsForComparison({
    searchTerm
  }), idsToSearch.length && getFormsBatch(idsToSearch)]).then(results => results.reduce((acc, {
    forms,
    xhr
  }) => {
    if (xhr && xhr.status >= 400) {
      Log.error(`Error fetching forms for Comparison Tool`, {
        error: xhr.error
      });
    }
    return [/* eslint-disable-next-line hubspot-dev/no-reduce-accumulator-copy */
    ...acc, ...(forms ? forms.map(form => ({
      text: form.name,
      value: form.guid,
      content: form
    })) : [])];
  }, []));
};
const fetchFormDetails = ({
  contentObject
}) => {
  return getForm(contentObject.guid).then(results => Object.assign({}, results));
};
const fetchFormDetailedAnalytics = ({
  contentObject,
  startTimestamp,
  endTimestamp
}) => getFormsDetailsForComparison({
  guid: contentObject.guid,
  startDate: timestampToStartDate(startTimestamp),
  endDate: timestampToEndDate(endTimestamp)
}).then(results => Object.assign({}, results));
export const fetchFormData = ({
  contentObject: {
    contentObject
  },
  startTimestamp,
  endTimestamp
}) => (dispatch, getState) => {
  const formInRedux = getComparisonToolFormDefinition(getState(), contentObject.guid, startTimestamp, endTimestamp);
  if (formInRedux) return Promise.resolve(formInRedux);
  dispatch(requestComparisonForms(contentObject, startTimestamp, endTimestamp));
  const analyticsPromise = fetchFormDetailedAnalytics({
    contentObject,
    startTimestamp,
    endTimestamp
  });
  const detailsPromise = fetchFormDetails({
    contentObject
  });
  return Promise.allSettled([analyticsPromise, detailsPromise]).then(results => {
    const fails = results.filter(result => result.status === 'rejected');
    if (fails.length) return failGettingComparisonForms(contentObject, fails, startTimestamp, endTimestamp);
    const comparisonForms = Object.assign({}, results[0].value[0], results[1].value);
    dispatch(receiveComparisonForms(contentObject, comparisonForms, startTimestamp, endTimestamp));
    return comparisonForms;
  });
};